import { ACCOUNT_INVOICE_INDEX } from 'client/redux/account/constants';
import * as actionCreators from 'client/redux/account/actionCreators';

export const accountInvoiceIndex = (query) => dispatch => {
  return dispatch(actionCreators.accountInvoiceIndex(ACCOUNT_INVOICE_INDEX, query));
};
